/* global Blockly */
import React from 'react';
import PropTypes from 'prop-types';

function defineBlock() {
    return {
        init: function () {
            this.appendDummyInput()
                .appendField("navigate back");
            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(Blockly.Msg.APP_ACTIONS_HUE);
            this.setTooltip('Navigate to the previous page in the application.');
            this.setHelpUrl(Blockly.BASE_HELP_URL + "#app-actions");
        }
    }
}

function defineGenerators() {
    return {
        "JavaScript": function () {
            let code = ('appContextModule.popFromNavigationStack();\n');
            return code;
        }
    }
}

const SnapActionNavigateBack = function (props) {
    const name = "snap_action_navigate_back";
    SnapActionNavigateBack.blockName = name;

    Blockly.Blocks[name] = defineBlock();

    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    if (props.context.pages.length < 2) {
        return null;
    }

    return (
        <block type={name}></block>
    );
};

SnapActionNavigateBack.propTypes = {
    context: PropTypes.object.isRequired
};

export default SnapActionNavigateBack;